// start:ng42.barrel
export * from './home/home.component';
// end:ng42.barrel

